import { useState } from "react";
import { Phone, Delete, X } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "0", "#"];

export default function Dialer({ open, onOpenChange }) {
  const [num, setNum] = useState("");

  function press(k) { setNum((s) => s + k); }
  function clear() { setNum((s) => s.slice(0, -1)); }

  async function call() {
    if (!num) return;
    toast.success(`Calling ${num}…`, { description: "Outbound dialer (simulated)" });
    onOpenChange(false);
    setNum("");
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-xs p-0 overflow-hidden">
        <DialogHeader className="px-5 pt-5">
          <DialogTitle className="font-display tracking-tight">WebRTC Dialer</DialogTitle>
          <DialogDescription className="text-xs">Outbound call from your registered number</DialogDescription>
        </DialogHeader>
        <div className="px-5">
          <div className="relative">
            <Input data-testid="dialer-number-input" value={num} onChange={(e) => setNum(e.target.value.replace(/[^0-9*#+ ]/g, ""))} placeholder="+91 …" className="text-center text-2xl font-display font-bold h-14 mt-2 tracking-widest" />
            {num && <button onClick={() => setNum("")} className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"><X className="w-4 h-4" /></button>}
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2 p-5">
          {KEYS.map((k) => (
            <button
              key={k}
              data-testid={`dialer-key-${k}`}
              onClick={() => press(k)}
              className="h-12 rounded-md bg-muted hover:bg-muted/80 font-display font-bold text-lg active:scale-95 transition"
            >{k}</button>
          ))}
        </div>
        <div className="flex items-center gap-2 px-5 pb-5">
          <Button data-testid="dialer-backspace" variant="outline" onClick={clear} className="flex-1 gap-2"><Delete className="w-4 h-4" /> Backspace</Button>
          <Button data-testid="dialer-call" onClick={call} className="flex-1 gap-2 bg-emerald-600 hover:bg-emerald-700 text-white"><Phone className="w-4 h-4" /> Call</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
